(() => {
  class CountdownFlip extends CountdownTimer {
    constructor() {
      super();
      this.flipDurationMs = 600;
    }

    updateDisplay(hoursValue, minutesValue, secondsValue) {
      if (this.daysEl) {
        const daysValue = this.daysEl.textContent || "00";
        this.updateFlip(this.daysEl, daysValue);
      }
      this.updateFlip(this.hoursEl, hoursValue);
      this.updateFlip(this.minutesEl, minutesValue);
      this.updateFlip(this.secondsEl, secondsValue);
    }

    updateFlip(unitEl, value) {
      if (!unitEl) return;

      const top = unitEl.querySelector("[data-countdown-static-top]");
      const bottom = unitEl.querySelector("[data-countdown-static-bottom]");
      const animTop = unitEl.querySelector("[data-countdown-anim-top]");
      const animTopText = unitEl.querySelector(
        "[data-countdown-anim-top-text]"
      );
      const animBottom = unitEl.querySelector("[data-countdown-anim-bottom]");
      const animBottomText = unitEl.querySelector(
        "[data-countdown-anim-bottom-text]"
      );

      if (
        !top ||
        !bottom ||
        !animTop ||
        !animTopText ||
        !animBottom ||
        !animBottomText
      ) {
        unitEl.textContent = value;
        unitEl.dataset.value = value;
        return;
      }

      const current = unitEl.dataset.value;
      if (!current) {
        top.textContent = value;
        bottom.textContent = value;
        animTopText.textContent = value;
        animBottomText.textContent = value;
        unitEl.dataset.value = value;
        return;
      }

      if (current === value) return;

      unitEl.classList.remove("is-flipping");

      top.textContent = value;
      bottom.textContent = current;
      animTopText.textContent = current;
      animBottomText.textContent = value;
      unitEl.dataset.value = value;

      void unitEl.offsetHeight;
      unitEl.classList.add("is-flipping");

      if (unitEl.flipTimeoutId) {
        clearTimeout(unitEl.flipTimeoutId);
      }

      unitEl.flipTimeoutId = setTimeout(() => {
        const nextValue = unitEl.dataset.value || value;
        unitEl.classList.remove("is-flipping");
        top.textContent = nextValue;
        bottom.textContent = nextValue;
        animTopText.textContent = nextValue;
        animBottomText.textContent = nextValue;
      }, this.flipDurationMs);
    }
  }

  if (!customElements.get("countdown-flip")) {
    customElements.define("countdown-flip", CountdownFlip);
  }
})();
